import React, { useEffect, useState } from "react";
import "./select-dashboard-modal.css";
import budgetImg from "../../assets/images/big/selected-components/budget.png";
import chatImg from "../../assets/images/big/selected-components/chat.png";
import goalImg from "../../assets/images/big/selected-components/goal-saving.png";
import goalprogress from "../../assets/images/big/selected-components/goal-progress.png";
import upcomingImg from "../../assets/images/big/selected-components/upcoming-bills.png";
import investmentwatchlist from "../../assets/images/big/selected-components/investment-watchlist.png";
import dashboardCalendar from "../../assets/images/big/selected-components/calendar.png";
import incomeExpense from "../../assets/images/big/selected-components/icome-expense.png";
import portBalance from "../../assets/images/big/selected-components/portfolio-balance.png";
import latestNews from "../../assets/images/big/selected-components/latest-news.png";
import tasklist from "../../assets/images/big/selected-components/task-list.png";
import monthlyExpense from "../../assets/images/big/selected-components/monthly-expense.png";
import storedImg from "../../assets/images/big/selected-components/stored-documents.png";
import twitterFeed from "../../assets/images/big/selected-components/twitterfeeds.png";
import newgoals from "../../assets/images/big/selected-components/new-goals.png";
import floatingImage from "../../assets/images/big/selected-components/waterfloatingimage.png";
import generalMain from "../../assets/images/big/selected-components/general-main.png";
import smallCalendar from "../../assets/images/big/selected-components/small-calendar.png";
import recurringBillsImage from "../../assets/images/big/selected-components/recurring-bills.png";
import { useHistory } from "react-router-dom";
import { Switch } from "antd";

const cardData = [
  { name: "Chat", title: "ChatComponentDashboard", image: chatImg },
  {
    name: "Income & Expense",
    title: "IncomeAndExpensChart",
    image: incomeExpense,
  },
  { name: "Upcoming Bills", title: "UpcomingBillsTable", image: upcomingImg },
  { name: "Calendar", title: "DashboardCalendar", image: dashboardCalendar },
  {
    name: "Investment Watchlist",
    title: "InvestmentWatchlistTable",
    image: investmentwatchlist,
  },
  { name: "Budget Expense", title: "budgetExpanse", image: budgetImg },
  { name: "Goal Progress", title: "goalProgress", image: goalprogress },
  { name: "Goals", title: "dashboardGoalCharts", image: goalImg },
  { name: "Saving Goals", title: "DashboardSavingsGoal", image: floatingImage },
  {
    name: "Portfolio Balances",
    title: "PortfolioBalancesTable",
    image: portBalance,
  },
  {
    name: "Small Calendar",
    title: "MiniCalendar",
    image: smallCalendar,
  },
  { name: "Latest News", title: "LatestNews", image: latestNews },
  {
    name: "Top Monthly Expense",
    title: "topMonthlyExpanse",
    image: monthlyExpense,
  },
  { name: "Task List", title: "TasksList", image: tasklist },
  { name: "All Goals", title: "dashboardGoalSection", image: newgoals },
  { name: "Stored Documents", title: "StoredDocumentsTable", image: storedImg },
  { name: "Twitter Feeds", title: "TwitterFeeds", image: twitterFeed },
  { name: "Account Balances", title: "generalMain", image: generalMain },
  {
    name: "Recurring Transactions",
    title: "RecurringBillsTable",
    image: recurringBillsImage,
  },
];

const SelectDashboard1 = ({
  handleCardSelectDashboard1,
  originalSettings,
  theme,
}) => {
  const [selectedCards, setSelectedCards] = useState(
    Array(cardData.length).fill(false)
  );
  const history = useHistory();

  useEffect(() => {
    const initialSelected = cardData.map(
      (card) =>
        originalSettings.dashboard1DragCards &&
        originalSettings.dashboard1DragCards.some(
          (item) => item.id === card.title
        )
    );
    setSelectedCards(initialSelected);
  }, [originalSettings]);

  const handleToggleSelect = (index) => {
    const updatedSelectedCards = [...selectedCards];
    updatedSelectedCards[index] = !updatedSelectedCards[index];
    setSelectedCards(updatedSelectedCards);

    handleCardSelectDashboard1(
      cardData[index].title,
      updatedSelectedCards[index]
    );
  };

  const handleSelectAll = (checked) => {
    const updatedSelectedCards = Array(cardData.length).fill(checked);
    setSelectedCards(updatedSelectedCards);
    cardData.forEach((card, index) => {
      handleCardSelectDashboard1(card.title, checked);
    });
  };
  const handleSelectProfile = (checked) => {
    const updatedSelectedCards = Array(cardData.length).fill(checked);
    setSelectedCards(updatedSelectedCards);
    cardData.forEach((card, index) => {
      handleCardSelectDashboard1(card.title, checked);
    });
  };

  return (
    <div
      style={{
        backgroundColor: theme === "dark" ? "rgb(35, 35, 35)" : "#ffffff",
        borderColor: theme === "dark" ? "#ffffff" : "#2a3da3",
      }}
      className="selected-dashboard-main-container"
    >
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          marginBottom: "20px",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <p
          style={{
            fontSize: "18px",
            fontWeight: "600",
            margin: "0",
            color: theme === "dark" ? "#ffffff" : "#2a3da3",
          }}
        >
          Select/Unselect All
        </p>
        <Switch onChange={handleSelectAll} />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          marginBottom: "20px",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <p
          style={{
            fontSize: "18px",
            fontWeight: "600",
            margin: "0",
            color: theme === "dark" ? "#ffffff" : "#2a3da3",
          }}
        >
          Revert this Dashboard to my {" "}
          <span style={{cursor:"pointer", color:"#09A84D"}} onClick={()=>{
            history.push("/questioner")
          }}>Profile 
          </span>
        </p>
        <Switch onChange={handleSelectProfile} />
      </div>
      <div className="selected-dashboard-container">
        {cardData &&
          cardData.map((card, index) => (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "row",
                  alignItems: "center",
                  width: "100%",
                  padding: "10px",
                }}
              >
                <h1
                  style={{
                    fontSize: "20px",
                    color: theme === "dark" ? "#ffffff" : "#2a3da3",
                  }}
                >
                  {card.name}
                </h1>
                <button
                  className="add-widgets-button"
                  style={{
                    backgroundColor: selectedCards[index]
                      ? "rgb(160, 160, 160)"
                      : "#2a3da3",
                  }}
                  type="primary"
                  onClick={() => handleToggleSelect(index)}
                >
                  {selectedCards[index] ? "Selected" : "Select"}
                </button>
              </div>
              <img
                alt="example"
                src={card.image}
                style={{
                  width: "100%",
                  objectFit: "cover",
                }}
              />
            </div>
          ))}
      </div>
    </div>
  );
};

export default SelectDashboard1;
